export default __webpack_public_path__ + "static/media/lacak_full_white.9b13ab25.png";